// extracted by mini-css-extract-plugin
module.exports = {"title":"RestaurantDetail_title__MeoID","wrapper_menu":"RestaurantDetail_wrapper_menu__3iHSA"};